import { colors } from '../../Colors/colors'

export const selfServeTemplates = {
   light: {
      common: {
         closeIconBGColor: colors['gray-500'],
         sections: {
            plusIconFillColor: colors['primary-600'],
            addSectionButtonBGColor: '!bg-transparent',
            sectionCard: {
               sectionNameTextColor: 'text-gray-600',
               sectionCardBGColor: 'bg-white',
               countTextColor: 'text-gray-700',
               selectedBorderColor: 'border-primary-600'
            },
            defaultSection: {
               iconFillColor: colors['gray-700'],
               menuBGColor: 'hover:bg-gray-50',
               dotsMoveIconFillColor: colors['gray-500']
            },
            deletedSection: {
               trashIconColor: colors['gray-500'],
               flipBackwardIconColor: colors['gray-500']
            },
            sectionPopoverMenu: {
               editIconFillColor: colors['gray-500'],
               deleteIconFillColor: colors['error-600'],
               editButtonTextColor: 'text-gray-900',
               deleteButtonTextColor: 'text-error-600'
            }
         },
         fields: {
            sectionHeader: {
               sectionName: 'text-gray-900',
               sectionDescription: 'text-gray-700',
               tooltipBGColor: 'bg-gray-900'
            },
            createCustomField: {
               titleText: 'text-gray-900',
               descriptionText: 'text-gray-600',
               fieldTypeOption: 'text-gray-700 ',
               selectedIconColor: colors['primary-600'],
               separationLineColor: 'bg-gray-300',
               searchIconColor: colors['gray-500'],
               corePropertiesTitle: 'text-gray-900',
               corePropertiesFooterBorder: 'border-gray-300',
               morePropertiesNavTex: 'text-gray-800',
               morePropertiesNavIcon: colors['gray-500'],
               backIcon: colors['gray-500']
            }
         },
         errorMessages: {
            userIsNotAdministrator: {
               containerBGColor: 'bg-gray-100',
               titleColor: 'text-gray-900',
               descriptionColor: 'text-gray-600'
            }
         }
      },
      autoGenerateCustomIdToggle: {
         description: 'text-gray-700',
         titleTextColor: 'text-gray-900'
      },
      contactTemplates: {
         body: {
            bodyBGColor: 'bg-gray-100',
            horizontalLineColor: 'border-gray-200'
         },
         fields: {},
         header: {
            headerBGColor: 'bg-white',
            borderColor: 'border-gray-300',
            headerTextColor: 'text-gray-900',
            settingsIconColor: colors['gray-700']
         },
         collapsibleSection: {
            chevronIconColor: colors['gray-500'],
            sectionTextColor: 'text-gray-600',
            lineBGColor: 'bg-gray-300'
         },
         displayNamesModel: {
            titleTextColor: 'text-gray-900',
            descriptionTextColor: 'text-gray-600',
            modelIconColor: colors['gray-500']
         }
      },
      deleteSection: {
         deleteSectionNameTextColor: 'text-gray-700',
         deleteSectionNameBorderColor: 'border-gray-300'
      },

      createOrUpdateSection: {
         headerTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600',
         fieldLabelTextColor: 'text-gray-700',
         toggleLabelColor: 'text-gray-700',
         toggleSwitchBgColor: colors['gray-100']
      },
      restoreSection: {
         prefixIconBGColor: 'bg-primary-100',
         prefixIconBorderColor: 'border-primary-50',
         headerTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600',
         flipBackwardIconBGColor: colors['primary-600'],
         restoreSectionNameTextColor: 'text-gray-700',
         restoreSectionNameBorderColor: 'border-gray-300'
      },
      customSectionFieldTable: {
         headerColumnStyles: 'text-gray-500',
         cellLabelStyles: 'text-gray-800',
         cellDataStyles: 'text-gray-600',
         editIconColor: colors['gray-500'],
         menuTriggerIconColor: colors['gray-700'],
         menuTriggerHoverColor: 'hover:bg-gray-50',
         menuOptions: {
            optionTextColor: 'text-gray-900',
            hoverBgColor: 'hover:bg-gray-50',
            borderColor: 'border-gray-200',
            iconColor: colors['gray-700'],
            editIconFillColor: colors['gray-500'],
            deleteIconFillColor: colors['error-600'],
            editButtonTextColor: 'text-gray-900',
            deleteButtonTextColor: 'text-error-600',
            moveButtonIconFillColor: colors['gray-500'],
            moveButtonTextColor: 'text-gray-900',
            restoreButtonIconFillColor: colors['gray-500'],
            restoreButtonTextColor: 'text-gray-900'
         },
         fieldTypeIconColor: colors['gray-500']
      },
      deletedSectionFieldsTable: {
         trashIconColor: colors['gray-500'],
         deletedFieldsTextColor: 'text-gray-600',
         separatorLineBgColor: 'bg-gray-300',
         chevronIconColor: colors['gray-500']
      },
      fieldOptions: {
         addOptionsTextColor: 'text-gray-900',
         optionsErrorTextColor: 'text-error-600',
         optionsSectionBGColor: 'bg-white',
         inputOptionsCountTextColor: 'text-gray-600'
      },
      moveField: {
         sectionNameTextColor: 'text-gray-700',
         sectionCardBGColor: 'bg-primary-50',
         sectionCardBorderColor: 'border-primary-600',
         headerTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600',
         closeIconColor: colors['gray-500'],
         defaultBorderColor: 'border-gray-200',
         selectedSectionTextColor: 'text-primary-600',
         selectedSectionRadioBorderColor: colors['primary-300'],
         selectedSectionRadioDotColor: colors['primary-600'],
         selectedSectionRadioBGColor: 'bg-primary-100',
         unSelectedSectionRadioBorderColor: colors['gray-300'],
         unSelectedSectionRadioBGColor: 'bg-gray-100'
      },
      deleteField: {
         deleteFieldNameTextColor: 'text-gray-700',
         deleteFieldNameBorderColor: 'border-gray-300'
      },
      restoreField: {
         restoreFieldNameTextColor: 'text-gray-700',
         restoreFieldNameBorderColor: 'border-gray-300'
      },
      configurations: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-700',
         cardBgColor: 'bg-white'
      },
      enableContactsToggle: {
         description: 'text-gray-700',
         titleTextColor: 'text-gray-900'
      },
      dependentOptions: {
         sectionDividerColors: 'bg-gray-300 border-gray-300',
         sectionHeaderTextColor: 'text-gray-900',
         chevronDownIconColor: colors['gray-500']
      }
   },

   dark: {}
}
